import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

import { Loading } from './Loading';
import { UserContext, SnackbarContext } from './userContext';
import { AccountHeader, EmptyBlock, Icon } from './myacc/primitives';

function StatusPill({ s }) {
  if (s === '1') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full border border-amber/40 bg-amber/12 px-2 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.14em] text-amber">
        <span aria-hidden className="h-1 w-1 rounded-full bg-amber animate-pulse" />
        Active
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-border-subtle bg-surface-overlay/60 px-2 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
      <span aria-hidden className="h-1 w-1 rounded-full bg-fg-muted" />
      {s === '0' ? 'Inactive' : 'Deleted'}
    </span>
  );
}

function Line({ label, children }) {
  return (
    <div className="text-[12.5px] leading-[1.5]">
      <span className="text-fg-tertiary">{label}: </span>
      <span className="font-semibold text-fg-primary break-words">{children}</span>
    </div>
  );
}

export const MyAccContactedCustomers = () => {
  const history = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Axios.post('/new_apis/getcontactedcustomers',
      { uid: user.user_id, cat: user.category_ids, role: user.user_role },
      { headers: { tkn: user.token } },
    ).then((res) => {
      const s = res.data.status;
      if (s === 1) {
        setData(res.data.custhist || []);
        setLoading(false);
      } else if (s === 3) {
        history('/');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      } else if (s === 4) {
        setUser(null);
        history('/');
        localStorage.removeItem('estkn');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      }
    });
  }, []); // eslint-disable-line

  if (loading) return <Loading />;

  return (
    <>
      <AccountHeader
        kicker="Customers"
        title="Contacted customers"
        subtitle="People who reached out about your listed products or services."
      />

      {data.length === 0 ? (
        <EmptyBlock
          icon={<Icon.Users className="h-7 w-7" />}
          title="No contact requests yet"
          subtitle="When customers contact your listings, they'll appear here."
        />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {data.map((item, i) => (
            <article
              key={i}
              className="
                relative flex flex-col gap-2 overflow-hidden
                rounded-2xl border border-border-subtle bg-surface-paper p-4
                transition-[border-color,transform] duration-200 ease-out-soft
                hover:border-amber/30 hover:-translate-y-0.5
              "
            >
              <div className="flex items-start justify-between gap-2">
                <h3 className="text-[14px] font-bold tracking-[-0.01em] text-fg-primary line-clamp-2 leading-[1.3]">
                  {item.prod_name}
                </h3>
                <StatusPill s={item.product_status} />
              </div>
              <div className="border-t border-border-subtle pt-2.5 space-y-0.5">
                <Line label="Name">{item.first_name}</Line>
                <Line label="Mobile">{item.phone}</Line>
                {item.email && <Line label="Email">{item.email}</Line>}
                <Line label="Contacted">{item.contact_date}</Line>
              </div>
            </article>
          ))}
        </div>
      )}
    </>
  );
};
